var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileMultiple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_790:54671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9382 7.60417V8.10417H15.4382H20.8236H21.7923V18.375C21.7923 18.7618 21.6387 19.1327 21.3652 19.4062C21.0917 19.6797 20.7208 19.8333 20.334 19.8333H8.58398C8.19721 19.8333 7.82628 19.6797 7.55279 19.4062C7.2793 19.1327 7.12565 18.7618 7.12565 18.375V2.70833C7.12565 2.32156 7.2793 1.95063 7.55279 1.67714C7.82628 1.40365 8.19721 1.25 8.58398 1.25H9.08398H14.9382V2.21875V7.60417ZM21.7923 6.83211V7.86581L21.1771 7.25061L15.7917 1.8652L15.1765 1.25H16.2102L21.7923 6.83211ZM4.66732 22.7917H19.834V23.75H4.66732C4.28054 23.75 3.90961 23.5964 3.63612 23.3229C3.36263 23.0494 3.20898 22.6784 3.20898 22.2917V5.16667H4.16732V22.2917V22.7917H4.66732Z",
    fill: "#C7C9C7",
    stroke: "#C7C9C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_790:54671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.5,
    height: 23.5,
    fill: "white",
    transform: "translate(0.75 0.75)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileMultiple);
export default __webpack_public_path__ + "static/media/file_multiple.6a905b33.svg";
export { ForwardRef as ReactComponent };